import { render, staticRenderFns } from "./ProjectActionButton.vue?vue&type=template&id=87943308"
import script from "./ProjectActionButton.vue?vue&type=script&lang=js"
export * from "./ProjectActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports